import { render } from "./ErrorsInformationFan.vue?vue&type=template&id=8d9b8290&scoped=true&ts=true&lang=pug"
import script from "./ErrorsInformationFan.vue?vue&type=script&lang=ts"
export * from "./ErrorsInformationFan.vue?vue&type=script&lang=ts"

import "./ErrorsInformationFan.vue?vue&type=style&index=0&id=8d9b8290&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d9b8290"]])

export default __exports__